import React from 'react';
import { useParams, useRouteMatch } from 'react-router';
import { Layout, Result, Spin } from 'antd';
import { BusinessPartnerModuleMenu } from 'pages/BusinessPartnerManagement/BusinessPartnerModuleMenu';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import { QueryKey } from 'api/queryKey';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { Content } from 'common/StyledComponents';
import { BusinessPartnerManagementRouter } from 'pages/BusinessPartnerManagement/BusinessPartnerManagementRouter';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const TitlePartnerName = styled.div`
  margin-left: 25px;
  display: inline;
  font-size: 22px;
  font-weight: 600;
`;

export const TitlePartnerID = styled.div`
  margin-left: 9px;
  display: inline;
  font-size: 15px;
`;

const BusinessPartnerLayout = styled.div`
  display: flex;
  margin-top: 30px;
`;

const BusinessPartnerMenuContainer = styled.div`
  width: 200px;
`;

export const ContextContent = styled.div`
  padding-left: 24px;
  flex-grow: 1;
  max-width: calc(100% - 200px);
`;

const StyledBusinessPartnerMenu = styled(BusinessPartnerModuleMenu)`
  height: 100%;
`;

export const BusinessPartnerManagementPage = () => {
  const { businessPartnerId } = useParams();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { url } = useRouteMatch();
  const { isLoading, isSuccess, data } = useQuery(
    [QueryKey.BusinessPartner, businessPartnerId],
    () => {
      return BusinessPartnersAPI.fetchById(businessPartnerId);
    }
  );

  const intlMessage = useFormatMessage();

  return (
    <Layout>
      <Spin spinning={isLoading}>
        <Content style={{ minHeight: '30vh' }}>
          {!isLoading && (
            <>
              {data && (
                <>
                  <TitlePartnerName>{data.name}</TitlePartnerName>
                  <TitlePartnerID>[ID: {data.id}]</TitlePartnerID>
                </>
              )}
              <BusinessPartnerLayout>
                {isSuccess && data ? (
                  <>
                    <BusinessPartnerMenuContainer>
                      <StyledBusinessPartnerMenu routePrefix={url} />
                    </BusinessPartnerMenuContainer>
                    <ContextContent>
                      <BusinessPartnerManagementRouter
                        moduleCtx={{ rootUrl: url }}
                        businessPartnerCtx={data}
                      />
                    </ContextContent>
                  </>
                ) : (
                  <Result
                    status="warning"
                    title={intlMessage({
                      id: 'businessPartner.dataLoadingWarning',
                    })}
                  />
                )}
              </BusinessPartnerLayout>
            </>
          )}
        </Content>
      </Spin>
    </Layout>
  );
};
